// extracted by mini-css-extract-plugin
export default {"input":"ContestTypeInput_input__NAJMR","text":"ContestTypeInput_text__WD0lb"};